"use client";

import LoadingFallback from "@/components/layout/loading-fallback";
import { Iphone15Pro } from "@/components/magicui/iphone-15-pro";
import dynamic from "next/dynamic";
import { SectionContentCard, SectionWrapper } from "../section-structure";
const NewsletterForm = dynamic(() => import("../newsletter-form"), {
  ssr: false,
  loading: () => <LoadingFallback />
});
type NewsletterCTASectionProps = {
  title: string;
  description: string;
};
export default function NewsletterCTASection({
  title,
  description
}: NewsletterCTASectionProps) {
  return <SectionWrapper className="max-w-5xl" data-sentry-element="SectionWrapper" data-sentry-component="NewsletterCTASection" data-sentry-source-file="newsletter-cta-section.tsx">
      <SectionContentCard className="grid grid-cols-1 gap-8 py-0 md:grid-cols-2" data-sentry-element="SectionContentCard" data-sentry-source-file="newsletter-cta-section.tsx">
        <div className="relative mx-auto hidden h-72 w-full overflow-hidden md:block md:h-full">
          <div className="absolute inset-0 flex translate-y-10 cursor-pointer items-start justify-center transition md:translate-y-12 md:hover:translate-y-8">
            <Iphone15Pro src="/images/other/newsletter-header-image.png" data-sentry-element="Iphone15Pro" data-sentry-source-file="newsletter-cta-section.tsx" />
          </div>
        </div>

        <div className="py-8 md:py-12">
          <div className="prose dark:prose-invert">
            <h4 className="text-3xl font-semibold tracking-tight md:text-4xl">{title}</h4>
            <p className="text-lg tracking-wide">{description}</p>
            {/* <p className="text-sm">Newsletter service is currently in development phase. *</p> */}
          </div>

          <NewsletterForm data-sentry-element="NewsletterForm" data-sentry-source-file="newsletter-cta-section.tsx" />
        </div>
      </SectionContentCard>
    </SectionWrapper>;
}